export default __webpack_public_path__ + "static/media/Bell.a5d72be2.mp3";